import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-gutter-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_create_album_btn = _resolveComponent("create-album-btn")!
  const _component_albums_table = _resolveComponent("albums-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_create_album_btn, {
      "client-id": _ctx.clientId,
      color: "primary",
      rounded: "",
      onCreated: _ctx.prepend
    }, null, 8, ["client-id", "onCreated"]),
    _createVNode(_component_albums_table, {
      "client-id": _ctx.clientId,
      ref: "reports"
    }, null, 8, ["client-id"])
  ]))
}